export default function isImage(file: File) : boolean {
	const unsupportedImageTypes = ['image/tiff'];

	return file.type.indexOf('image/') === 0 && !unsupportedImageTypes.includes(file.type);
}
